module.exports = __webpack_public_path__ + "img/92506.f3adb819.jpg";